import React from 'react';
import { Progress, Typography } from 'antd';
import { type BrevoSyncEjecucion, porcentajeFase, computeFaseActual } from '../../api/brevoSyncApi';

const { Text } = Typography;

interface PhaseProgressProps {
  ejecucion: BrevoSyncEjecucion;
}

const PhaseProgress: React.FC<PhaseProgressProps> = ({ ejecucion }) => {
  const fase = computeFaseActual(ejecucion);
  const pctA = porcentajeFase(ejecucion.faseATotal, ejecucion.faseAExitos, ejecucion.faseAErrores);
  const pctB = porcentajeFase(ejecucion.faseBTotal, ejecucion.faseBExitos, ejecucion.faseBErrores);

  const aDone = ejecucion.faseAExitos + ejecucion.faseAErrores;
  const bDone = ejecucion.faseBExitos + ejecucion.faseBErrores;

  return (
    <div style={{ marginBottom: 16 }}>
      {/* Fase A */}
      <div style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
          <Text strong style={{ fontSize: 13 }}>Fase A — Sincronizar contactos elegibles</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {fase === 'loading' ? 'Esperando datos…' :
              pctA != null && ejecucion.faseATotal
                ? `${aDone.toLocaleString('es')} / ${ejecucion.faseATotal.toLocaleString('es')} · ${ejecucion.faseAErrores} errores`
                : 'Pendiente'}
          </Text>
        </div>
        <Progress
          percent={pctA ?? 0}
          status={fase === 'A' ? 'active' : (pctA != null && pctA >= 100 ? 'success' : 'normal')}
          size="small"
          showInfo={false}
          strokeColor={ejecucion.faseAErrores > 0 ? '#faad14' : undefined}
        />
      </div>

      {/* Fase B */}
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
          <Text strong style={{ fontSize: 13 }}>Fase B — Marcar contactos caídos</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {fase === 'B' && ejecucion.faseBTotal
              ? `${bDone.toLocaleString('es')} / ${ejecucion.faseBTotal.toLocaleString('es')} · ${ejecucion.faseBErrores} errores`
              : 'Empezará tras la fase anterior'}
          </Text>
        </div>
        <Progress
          percent={pctB ?? 0}
          status={fase === 'B' ? 'active' : (pctB != null && pctB >= 100 ? 'success' : 'normal')}
          size="small"
          showInfo={false}
        />
      </div>
    </div>
  );
};

export default PhaseProgress;
